import Cookies from "js-cookie";

// Genera la URL de login/redirección a ReservHotel a partir de las cookies de
// sesión del agente. Se reutiliza en la navegación (link directo) y en la
// página de Reserve Hotel (botón). Preserva la lógica original tal cual, incl.
// las credenciales por entorno (sandbox vs. producción) y el caso MXN (167).
export function buildReserveHotelUrl() {
  const countryUser = Cookies.get("CountryUser");
  const agencyCode = Cookies.get("AgencyReservHotelId") || "";
  const agentCode = Cookies.get("AgentReservHotelId") || "";
  const userAccessToken = Cookies.get("UserAccessToken") || "";

  let systemUsr = "TestAcct";
  let systemPwd = "R3S3rV23!";
  let hotelGroup = "P87E7";

  if (process.env.REACT_APP_ENVIRONMENT === "" || process.env.REACT_APP_ENVIRONMENT_PRODUCTION === "") {
    systemUsr = "MARIVALAPIUSR";
    systemPwd = "Str000ngP@!23";
    hotelGroup = "MARIVAL";

    if (countryUser === "167") {
      systemUsr = "MARIVALAPIUSRMXN";
      systemPwd = "Str000ngP@!23";
      hotelGroup = "MARIVALMXN";
    }
  }

  const redirectUrl = encodeURIComponent(
    `https://www.reservhotel.com/win/owa/TA_LOGIN_WS.ENTRY?agency=${agencyCode}&usr=${agentCode}&HGROUP=${hotelGroup}`
  );

  return `https://www.reservhotel.com/win/owa/TA_LOGIN_WS.LOGIN?system_usr=${systemUsr}&system_pwd=${systemPwd}&agency=${agencyCode}&usr=${agentCode}&token=${userAccessToken}&HGROUP=${hotelGroup}&REDIRECT_URL=${redirectUrl}`;
}
